import APIService from './APIService';
import store from '../store';
import PreferencesService from './PreferencesService';
import preferences from '../constants/preferences';
import config from '../../config';
import { dateConstants, dateMethods } from '@/helpers/dateHelper';

const { millisecondsInSecond } = dateConstants;
const { computeUnixTimestamp, modifyDate } = dateMethods;

export default class OnboardingService extends APIService {
  static getTimeStamp() {
    const minutes = 17;
    const modifiedDate = modifyDate({
      operation: 'add',
      amount: minutes,
      unit: 'minutes',
      getDateObj: true
    });
    const timestamp =
      computeUnixTimestamp({
        timestamp: modifiedDate,
        timeZone: 'utc'
      }) * millisecondsInSecond;

    return timestamp;
  }
  /**
   *
   * @param {*} type
   */

  static async subscribeService(type, selectedOrg) {
    let orgId = selectedOrg ? selectedOrg : store.state.currentlySelectedOrgId;
    const {
      data: { success, body }
    } = await PreferencesService.getPreferencesByPreferenceKey(
      preferences.ARCHIVE_TOOL_BOX_PROCESS_URLS
    );
    if (success) {
      const {
        0: { results }
      } = body;
      const {
        data: { processURLs }
      } = results.find(
        connector => connector.data.processURLs.SOURCE_ID === type
      );
      const timestamp = OnboardingService.getTimeStamp();
      const url = String(processURLs.SOURCE_ONBOARD_REQUEST_URL)
        .replace('{orgId}', orgId)
        .replace('{timestamp}', timestamp);

      const bodyString = String(processURLs.SOURCE_ONBOARD_BODY)
        .replace('{orgId}', orgId)
        .replace('{timestamp}', timestamp);
      return this.post(url, JSON.parse(bodyString));
    }
  }
  /**
   *
   * @param {*} type
   */
  static async unsubscribeService(type) {
    let orgId = store.state.currentlySelectedOrgId;
    const {
      data: { success, body }
    } = await PreferencesService.getPreferencesByPreferenceKey(
      preferences.ARCHIVE_TOOL_BOX_PROCESS_URLS
    );
    if (success) {
      const {
        0: { results }
      } = body;

      const {
        data: { processURLs }
      } = results.find(
        connector => connector.data.processURLs.SOURCE_ID === type
      );

      const timestamp = OnboardingService.getTimeStamp();
      const url = String(processURLs.SOURCE_UNSUBSCRIBE_REQUEST_URL)
        .replace('{orgId}', orgId)
        .replace('{timestamp}', timestamp);
      this.delete(url);
    }
  }

  /**
   *
   * @param {Number} step
   * @param {String} orgId
   * @param {String} type
   */
  static async onboardingOrg(orgId = store.state.currentlySelectedOrgId, type) {
    let url = config.onboardingService;

    const stepTypes = {
      o365_onedrive: 'connector',
      o365_sharepoint: 'connector',
      o365_group: 'usersync',
      o365_teams: 'connector',
      o365_email: 'connector',
      dropbox: 'connector',
      trigger: 'trigger',
      initialise: 'initialise',
      poll: 'poll'
    };
    const steps = {
      usersync: { endpoint: `/v2/onboarding/${orgId}/usersync` },
      initialise: { endpoint: `/v2/onboarding/${orgId}/initalize` },
      connector: { endpoint: `/v2/onboarding/${orgId}/connectors/${type}` },
      trigger: { endpoint: `/v2/onboarding/${orgId}/trigger` },
      poll: { endpoint: `/v2/onboarding/status/${orgId}` }
    };
    const currentStep = steps[stepTypes[type]];

    return this.get(`${url}${currentStep?.endpoint}`);
  }

  /**
   *
   * @param {Strin} orgId
   * @param {String} code , code received when user give consent of Dropbox
   * @param {String} connectorId , source Id of connector
   * @returns
   */
  static createDropboxAccessToken(orgId, code, connectorId) {
    const baseUrlForDropboxAdapterService =
      config.baseUrlForDropboxAdapterService;

    return this.post(
      `${baseUrlForDropboxAdapterService}/create-access-token/${orgId}`,
      {
        code,
        redirectURI: config.callbackrlForSSO,
        connector: connectorId
      }
    );
  }

  /**
   *
   * @param {String} connectorId , source Id of connector
   * @returns
   */
  static removeDropboxAccessToken(connectorId) {
    const baseUrlForDropboxAdapterService =
      config.baseUrlForDropboxAdapterService;
    const orgId = store.state.currentlySelectedOrgId;

    return this.delete(
      `${baseUrlForDropboxAdapterService}/remove-refresh-token/${orgId}?connector=${connectorId}`
    );
  }
}
